const VALIDATION_MAP = {
  pw: /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[0-9a-zA-Z!@#$%^&*]{8,16}$/,
  ph_number: /^010\d{4}\d{4}$/,
  koreanRegex: /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/,
};

export default VALIDATION_MAP;
